import React, { ChangeEvent, useRef } from 'react'
import Icon from '../icon'

export const ImageUploadButton: React.FC<{
  showText?: boolean
  className?: string
  handleChange: (val: ChangeEvent<HTMLInputElement>) => void
  iconDim?: number
  text?: string
  icon?: string
  dottedBorder?: boolean
}> = ({
  showText = true,
  handleChange,
  className = '',
  iconDim = 20,
  text = 'Click to upload image',
  icon = 'camera',
  dottedBorder = true,
}) => {
  const imageRef = useRef<HTMLInputElement | null>(null)

  return (
    <button
      type="button"
      onClick={() => {
        if (imageRef.current) {
          imageRef.current.value = ''
        }
        imageRef?.current?.click()
      }}
      className={`
      bg-transparent text-neutral
      absolute top-4 right-4
      py-4 px-4 rounded-full
      flex flex-col items-center justify-center gap-2
      text-sm
      ${className}
      `}
      style={{
        backgroundImage: dottedBorder
          ? `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%237A7978FF' stroke-width='2' stroke-dasharray='6%2c 8' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`
          : undefined,
      }}
    >
      <Icon id={icon} width={iconDim} height={iconDim} />
      {showText && <p className="">{text}</p>}
      <input
        type="file"
        accept="image/*"
        onChange={handleChange}
        className="!hidden"
        ref={imageRef}
      />
    </button>
  )
}
